import { useLocation } from "@tanstack/react-router";
import InviteForm from "../../modules/auth/InviteForm";
import ForgetPassForm from "../../modules/auth/ForgetPassForm";
import ResetPassword from "../../modules/auth/ResetPassword";

const PassSignIn = () => {
  const location = useLocation();

  let formType = "signup";

  if (location.searchStr.includes("?token=")) {
    formType = "invitation";
  } else if (location.searchStr.includes("?user_token=")) {
    formType = "new_password";
  } else if (location.pathname.includes("/resetpassword")) {
    formType = "reset_password";
  }

  return (
    <>
      {formType === "reset_password" ?
        <ForgetPassForm />
      : formType === "new_password" ?
        <ResetPassword />
      : formType === "invitation" ?
        <InviteForm />
      : null}
    </>
  );
};

export default PassSignIn;
